const acceptPrivacyPolicy = () => {
  setCookie('privacy-policy', true, 365)
}

const deletePrivacyPolicy = () =>  {
  setCookie('privacy-policy', '', 0)
}

const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

const getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  console.log('getCookie', ca)
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') { // eslint-disable-line
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) { // eslint-disable-line
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const isPrivacyPolicy = () => {
  return getCookie('privacy-policy') && getCookie('privacy-policy') !== ''
}

export {
  isPrivacyPolicy,
  deletePrivacyPolicy,
  acceptPrivacyPolicy
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy/utils.js